import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
const headers = new HttpHeaders()
  .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
  .set("Client-Service", "univate-training");
@Injectable({
  providedIn: 'root'
})
export class RulesService {
  private url = GlobalService.serverURL + 'recruiter/manage_all_rules/';
  constructor(
    private http: HttpClient
  ) { }
  getRules(data) {
    return this.http.post(this.url + 'get_rule', data, { headers })
  }
  submitRules(data) {
    return this.http.post(this.url + 'submit_value', data, { headers })
  }
}
